import * as Yup from 'yup';
import { IChangePasswordInputs, TChangePasswordStore, PasswordInputKeys } from './types';


// Изначальные данные полей ввода в форме изменения пароля
export const INITIAL_CHANGE_PASSWORD_STORE: TChangePasswordStore = {
	newPassword: {
		value: '',
		type: 'password',
		isValid: true,
		errorMessage: ''
	},
	repeatNewPassword: {
		value: '',
		type: 'password',
		isValid: true,
		errorMessage: ''
	},
}

const ALLOWED_SYMBOLS = '@.,+\\-_!?#$%^&*';

// 1) после удаления спецсимволов должны остаться только латиница/цифры и быть 1 lower + 1 upper
const LATIN_DIGITS_WITH_CASE = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]+$/;

// 2) вся строка может содержать только латиницу/цифры/разрешённые спецсимволы (символы НЕ обязательны)
const ONLY_ALLOWED_CHARS = new RegExp(`^[a-zA-Z0-9${ALLOWED_SYMBOLS}]+$`);

export const NEW_PASSWORD_SCHEMA = Yup.object({
  value: Yup.string()
    .required('Введите новый пароль')

    // Сначала: запрет символов (кириллица, пробелы, emoji и т.п.)
    .test(
      'only-allowed-chars',
      'Допускаются только латинские буквы, цифры и символы @.,+-_!?#$%^&*',
      (v) => !v || ONLY_ALLOWED_CHARS.test(v)
    )

    // Потом: латиница+цифры и минимум 1 строчная + 1 заглавная
    .test(
      'latin-digits-case',
      'Пароль должен содержать хотя бы одну строчную и одну заглавную латинскую букву',
      (v) => {
        if (!v) return false;

        // убираем разрешённые спецсимволы, чтобы проверка регистра не зависела от них
        const withoutSymbols = v.replace(/[@.,+\-_!?#$%^&*]/g, '');
        return LATIN_DIGITS_WITH_CASE.test(withoutSymbols);
      }
    )

    .min(8, 'Пароль должен быть не менее 8 символов')
    .max(30, 'Пароль не должен превышать 30 символов'),
});


// Схема валидации для повтора пароля
export const REPEAT_PASSWORD_SCHEMA = Yup.object({
    value: Yup.string()
		.required('Подтвердите новый пароль')
		.test('passwords-match', 'Пароли не совпадают', function (value) {
			const context = this.options.context;
			return context?.newPassword?.value === value;
		}),
});


// Схема валидации формы изменения пароля
export const CHANGE_PASSWORD_VALIDATION_SCHEMA = Yup.object().shape({
	newPassword: NEW_PASSWORD_SCHEMA,
	repeatNewPassword: REPEAT_PASSWORD_SCHEMA,
});


// Массив полей ввода для отрисовки
export const INPUTS_ARR: IChangePasswordInputs[] = [
	{
		label: 'Новый пароль',
		inputName: PasswordInputKeys.NEW_PASSWORD,
		options: [
			{
				optionText: 'Пароль должен содержать только латинские буквы',
				optionType: 'charactersCount',
			},
			{
				optionText: 'Допускаются цифры и символы @.,+\-_!?#$%^&*.',
				optionType: 'charactersCount',
			},
			{
				optionText: 'Пароль должен содержать как минимум 1 строчную и 1 заглавную букву',
				optionType: 'letterCase'
			},
			{
				optionText: 'Пароль должен содержать как минимум 8 символов',
				optionType: 'charactersCount',
			},
		],
	},
	{
		label: 'Повторите новый пароль',
		inputName: PasswordInputKeys.REPEAT_NEW_PASSWORD,
		options: []
	},
];
